import { CrudStoreItemOnboarding } from 'legacy/lut/classes/models/onboarding/CrudStoreItemOnboarding'
import { useCallback } from 'react'

import { Logic, Operator } from 'core-components/types'
import { CrudStore } from 'core/types/crudStore'
import { REGEX_TRIM_ALL_SPACES } from 'src/config/regexp'

interface IProps {
  companyName: string
  countryISO: string
  taxId: string
}

export const useAmsLatamDataCrud = ({ companyName, countryISO, taxId }: IProps) => {
  const crud = CrudStore.get(CrudStoreItemOnboarding.AplAmsLatamSearch)

  const applySearchFilter = useCallback(() => {
    crud.setFilter({
      logic: Logic.AND,
      filters: [
        {
          field: 'companyName',
          value: companyName.replace(REGEX_TRIM_ALL_SPACES, ''),
          operator: Operator.EQUAL,
        },
        {
          field: 'countryISO',
          value: countryISO,
          operator: Operator.EQUAL,
        },
        {
          field: 'taxId',
          value: taxId.replace(REGEX_TRIM_ALL_SPACES, ''),
          operator: Operator.EQUAL,
        },
      ],
    })
  }, [companyName, countryISO, taxId, crud])

  return {
    crud,
    applySearchFilter,
  }
}
